import { Modal, Button, Box, Grid } from "@mui/material";
import { H5 } from "./Typography";

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: () => void;
};

function KYCReduModel({ open, handleClose, handleSave }: MyModalProps) {
  const handleSaveClick = () => {
    handleSave();
  };
  const handleCloseSaveClick = async () => {
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
            }}
            fontWeight={"500"}
          >
            Redo KYC
          </H5>
        </Box>

        <Box sx={container}>
          <H5 fontWeight={400} sx={{ color: "#595959" }}>
            Are you sure about this? If you start this process you will not be
            able to access or make any investments until you finish the KYC
            process again! If you quit you will have to submit another support
            request for redoing the KYC.
          </H5>

          <Box sx={buttonContainer}>
            <Button
              variant="contained"
              onClick={handleCloseSaveClick}
              sx={close}
            >
              Quit
            </Button>
            <Button variant="contained" onClick={handleSaveClick} sx={add}>
              Start
            </Button>
          </Box>
        </Box>
      </Grid>
    </Modal>
  );
}

export default KYCReduModel;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",

  boxShadow: 2,

  borderRadius: 2,
  overflow: "hidden",
};
const close = {
  background: "#fff",
  color: "#000",
  width: {
    md: "80%",
    xs: "45%",
  },
  mb: 1,
  mr: 2,
  borderRadius: 2,
};
const header = {
  width: 400,
  bgcolor: "#0152B4",

  boxShadow: 2,
};
const container = {
  pl: 2,
  pr: 2,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: "90%",
  justifyContent: "center",
  flexDirection: "row",
  display: "flex",
  p: 1,
  mt: 1.5,
};

const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "80%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
